var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DynamicSvg, GradientView, useBreakpoint } from '@airtel/air-design-system';
import { getStatusCardSvgGradientStyles, getStatusCardSvgIconProps, getStatusCardSvgIconSize } from './StatusCardSvgSectionStyles';
export var StatusCardSvgSection = props => {
  var svgIconProps = getStatusCardSvgIconProps(props);
  var _props$svgBackgroundP = props.svgBackgroundProps,
    svgBackgroundProps = _props$svgBackgroundP === void 0 ? {} : _props$svgBackgroundP,
    iconName = props.iconName,
    _props$svgXml = props.svgXml,
    svgXml = _props$svgXml === void 0 ? '' : _props$svgXml,
    restProps = __rest(props, ["svgBackgroundProps", "iconName", "svgXml"]);
  var _svgBackgroundProps$t = svgBackgroundProps.type,
    type = _svgBackgroundProps$t === void 0 ? 'none' : _svgBackgroundProps$t;
  var _useBreakpoint = useBreakpoint({
      allowMdAsLargeScreen: true,
      returnAsObject: true
    }),
    isLargeScreen = _useBreakpoint.isLargeScreen;
  var platform = isLargeScreen ? 'web' : 'mobile';
  var backgroundStyles = getStatusCardSvgGradientStyles(svgBackgroundProps, platform);
  if (!iconName && !svgXml) return null;
  var Wrapper = _ref => {
    var children = _ref.children;
    return _jsx(_Fragment, {
      children: type === 'none' ? children : _jsx(GradientView, Object.assign({
        type: type,
        style: backgroundStyles.container
      }, {
        children: children
      }))
    });
  };
  return _jsxs(Wrapper, {
    children: [!!svgXml && _jsx(DynamicSvg, Object.assign({
      xml: svgXml
    }, restProps)), !!iconName && _jsx(DynamicSvg, Object.assign({
      iconName: iconName
    }, svgIconProps, {
      fontSize: getStatusCardSvgIconSize(props, platform)
    }))]
  });
};